module.exports = __webpack_public_path__ + "img/2.759b3f32.jpg";